import { locationTypes } from './locationsSlice'

export const typeLocationOptions = Object.entries(locationTypes).map(
  ([key, value]) => ({
    label: value, 
    value: key
  })
)